module.exports = __webpack_public_path__ + "img/Druid-nightelf-f-70.8b4ac078.gif";